export const BUSINESS_ERROR_CODES = {
    NO_ELIGIBLE_MEMBERS_FOUND: '0010',
    EXPIRED_MEMBERSHIP: '0020',
    STOLEN_MEMBERSHIP: '0030',
    DETAIL_MEMBERSHIP_ERROR: '0040',
    NOT_ELIGIBLE_MEMBERS: '0050',
    FIRST_NAME: '600004',
    ADDRESS: '600005',
    PROFANITY: '600017',
    PRIMARY_CARDHOLDER: '600025'
};
export const validErrorMessageCode = [
    BUSINESS_ERROR_CODES.NO_ELIGIBLE_MEMBERS_FOUND,
    BUSINESS_ERROR_CODES.EXPIRED_MEMBERSHIP,
    BUSINESS_ERROR_CODES.NOT_ELIGIBLE_MEMBERS
];
export const STATUS_CODE = {
    EXISTING_USER: '200',
    NEW_USER: '201',
    BUSINESS_ERROR: '422'
};
export const RESPONSE_STATUS = {
    BUSINESS_ERROR: 422,
    FORBIDDEN: 403
};
